import { Injectable } from '@angular/core';
import { ApiService} from '../../../../core/service/api.service';
import { Observable} from 'rxjs/Observable';
import { ElementLog} from '../model/element-log';

@Injectable()
export class ElementLogsService {

  constructor(private api: ApiService) { }

  getElementLogs (phone: any): Observable<any>{
    return this.api.get('vna/elements_logs',{'phone':phone})
          .map( (row: Array<Object>) => {
                  return row.map(function (obj) {
                      const element_log = new ElementLog(obj);
                      return element_log;
                  })
              }
          );
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/elements/services/element-logs.service.ts